module.exports = __webpack_public_path__ + "static/media/wig1.d7909e26.jpg";